import { request2 } from './request.js'

// 跟踪记录初始化
export function getBaseInfo(studentId) {
  return request2({
    url: 'api2/TZsbAdminStudentApi/Track/GetBaseInfo?studentId=' + studentId,
    method: 'get',
  });
}
//获取学员跟踪记录--包括查看指定学员跟踪记录
//(如果是查看指定学员跟踪记录请设置为50)
export function getStudentTracksRecord(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Track/StudentTrackList',
    method: 'get',
    params: {
      StudentId: obj.StudentId,
      BusinessId: obj.BusinessId,
      StudentName: obj.StudentName,
      Desp: obj.Desp,
      PageIndex: obj.PageIndex,
      PageSize: obj.PageSize,
    }
  })
}
//添加跟踪记录
export function addTrack(obj) {
  return request2({
    // url: '/api2/TZsbAdminApi/Track/AddTrack',
    url: '/api2/TZsbAdminStudentApi/Track/AddTrack',
    method: 'post',
    data: obj
  });
}
//编辑跟踪记录
export function editTrack(obj) {
  return request2({
    // url: '/api2/TZsbAdminApi/Track/EditTrack',
    url: '/api2/TZsbAdminStudentApi/Track/EditTrack',
    method: 'post',
    data: obj
  });
}
//获取单条跟踪记录
export function getTrack(id) {
  return request2({
    // url: 'api2/TZsbAdminApi/Track/GetTrack',
    url: 'api2/TZsbAdminStudentApi/Track/GetTrack',
    method: 'get',
    params: {
      trackId: id
    }
  });
}
//删除跟踪记录
export function deleteTrack(ids) {
  return request2({
    // url: 'api2/TZsbAdminApi/Track/Deletes',
    url: 'api2/TZsbAdminStudentApi/Track/Deletes',
    method: 'post',
    data: ids
  });
}

